import React from "react";

const IconSubscription = ({ ...props }) => {
  return (
    <svg
      viewBox="0 0 78 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M42.6364 2.9525L47.5064 22.5625C48.1664 25.2125 50.6364 27.0125 53.3564 26.8125L73.5164 25.3825C77.5764 25.0925 79.3064 30.4325 75.8564 32.5825L58.7064 43.2725C56.3864 44.7225 55.4464 47.6225 56.4664 50.1525L64.0564 68.8825C65.5864 72.6525 61.0464 75.9525 57.9364 73.3325L42.4664 60.3225C40.3764 58.5625 37.3264 58.5625 35.2364 60.3225L19.7664 73.3325C16.6564 75.9525 12.1164 72.6525 13.6464 68.8825L21.2364 50.1525C22.2664 47.6225 21.3164 44.7125 18.9964 43.2725L1.84644 32.5925C-1.60356 30.4425 0.126444 25.1025 4.18644 25.3925L24.3464 26.8225C27.0764 27.0125 29.5464 25.2225 30.1964 22.5725L35.0664 2.9625C36.0464 -0.9875 41.6564 -0.9875 42.6364 2.9625V2.9525Z" />
    </svg>
  );
};

export default IconSubscription;
